import {styled} from '@material-ui/core/styles';
import {Box} from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .bgW': {
        width: '285px',
        backgroundColor: '#fff',
    },
    '& .tableTool': {
        padding: '16px',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
        '& .textDateField':{
            margin: '0 10px',
        },
        '& .status-block': {
            margin: '0 0 0 36px',
            '& .textField': {
                margin: '0 10px',
                width: '200px',
            }
        },
        '& .searchWapper': {
            border: '1px solid #CCCCCC',
            borderRadius: '3px',
            width: '220px',
            height: '38px',
            '& .search': {
                height: '32px',
                color: '#58727C',
                padding: '0 10px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            border: '1px solid #CCCCCC',
        },
    },
    '& .statisticBar': {
        padding: '16px',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
        justifyContent: 'flex-end',
    },
    '& .textWapper': {
        borderLeft: '1px solid #979797',
        padding: '0 13px',
        width: '150px',
        '& .title': {
            color: '#979797',
            fontSize: '12px',
        },
        '& .time': {
            marginTop: '5px',
            fontSize: '18px',
        },
    },
    '& .tableWapper': {
        width: '100%',
        overflowX: 'auto',
        '& .table': {
            minWidth: '650px',
        }
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .btn': {
        width: '186px',
    },
    '& .m-20': {
        margin: '0 20px',
    },
    '& .wLong': {
        width: '346px !important',
    },
    '& .colorGreen': {
        backgroundColor: '#43D79E',
    },
    '& .colorBlue': {
        backgroundColor: '#18C6FF',
    },
    '& .colorYellow': {
        backgroundColor: '#fcba03',
    },
    '& .colorGrey': {
        backgroundColor: '#C1C0C2',
    },
    '& .colorCombo': {
        backgroundColor: 'rgb(252,186,3)',
        background: 'linear-gradient(155deg, rgba(252,186,3,1) 10%, rgba(67,215,158,1) 47%, rgba(24,198,255,1) 52%, rgba(193,192,194,1) 95%)',
    },
    '& .stateBall': {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        marginRight: '5px',
        marginBottom: '-2px',
        display: 'inline-block',
    },
});